import moment from 'moment';

export default {
  accountId: '',
  universeId: '',
  dateRange: {
    start: moment().subtract('6', 'day').startOf('day'),
    end: moment().endOf('day'),
  },
  globalFilter: {},
};
